/* const RequestMethodsEnum = {
     JSON: 'application/jsoncharset=UTF-8',
     // form-data   上传资源（图片，视频）
     FORM_DATA: 'multipart/form-datacharset=UTF-8',
     GET: 'GET',
     POST: 'POST',
     SUCCESS: 1,
     FAIL: 0,
     LOGIN_FAILURE: -1,
     OPEN_NEW_PAGE: 2
} */
import axios from 'axios'
// import { isFunction, merge, cloneDeep } from 'lodash'
import axiosCancel from './cancel'
//  import  { RequestData, RequestOptions } from './type'
// import useAppStore from '@/stores/modules/app'
// import { CustomCrypto }  from './crypto'
//  import req from './cryptoServ'
//  import axios from 'axios'
// const CryptoJS = require("crypto-js")
// import {decodeCookie} from '../../api/app'
export class Axios {
    constructor (config) {
        this.config = config
        this.options = config.requestOptions
        this.axiosInstance = axios.create(config)
        this.setupInterceptors()
    }

    getAxiosInstance () {
        return this.axiosInstance
    }

    setupInterceptors () {
        if (!this.config.axiosHooks) {
            return
        }
        const {
            requestInterceptorsHook,
            requestInterceptorsCatchHook,
            responseInterceptorsHook,
            responseInterceptorsCatchHook
        } = this.config.axiosHooks
        this.axiosInstance.interceptors.request.use(
            (config) => {
                this.addCancelToken(config)
                if (typeof requestInterceptorsHook === 'function') {
                    config = requestInterceptorsHook(config)
                }
                return config
            },
            (err) => {
                if (typeof requestInterceptorsCatchHook === 'function') {
                    requestInterceptorsCatchHook(err)
                }
                return err
            }
        )
        this.axiosInstance.interceptors.response.use(
            (response) => {
                this.removeCancelToken(response.config.url)
                if (typeof responseInterceptorsHook === 'function') {
                    response = responseInterceptorsHook(response)
                }
                return response
            },
            (err) => {
                if (typeof responseInterceptorsCatchHook === 'function') {
                    responseInterceptorsCatchHook(err)
                }
                if (err.code !== 'ECONNABORTED' && err.code !== 'ERR_NETWORK') {
                    // this.removeCancelToken(err.config?.url)
                    if (err.config && err.config.url) {
                        this.removeCancelToken(err.config.url)
                    }
                }
                if (err.code === 'ECONNABORTED' || err.code === 'ERR_NETWORK') {
                    return new Promise((resolve) => setTimeout(resolve, 500)).then(() =>
                        this.retryRequest(err)
                    )
                }
                return Promise.reject(err)
            }
        )
    }

    addCancelToken (config) {
        const { ignoreCancelToken } = config.requestOptions
        !ignoreCancelToken && axiosCancel.add(config)
    }

    removeCancelToken (url) {
        axiosCancel.remove(url)
    }

    retryRequest (error) {
        const config = error.config
        const { retryCount, isOpenRetry } = config.requestOptions
        if (!isOpenRetry || (config.method && config.method.toUpperCase() === 'POST')) {
            return Promise.reject(error)
        }
        if (!config.retryCount) {
            config.retryCount = 0
        }

        if (config.retryCount >= retryCount) {
            return Promise.reject(error)
        }
        config.retryCount++
        return this.axiosInstance.request(config)
    }

    get (config, options) {
        return this.request({ ...config, method: 'GET' }, options)
    }

    post (config, options) {
        return this.request({ ...config, method: 'POST' }, options)
    }

    request (config, options) {
        const opt = Object.assign({}, this.options, options)
        const axioxConfig = {
            ...config,
            requestOptions: opt
        }
        const { urlPrefix } = opt
        if (urlPrefix) {
            axioxConfig.url = `${urlPrefix}${config.url}`
        }
        return new Promise((resolve, reject) => {
            this.axiosInstance
                .request(axioxConfig)
                .then((res) => {
                    //  这里可以在做一些拦截api/pc/getConfig处理
                    //  let getConf = useAppStore().config.dataSet
                    // let getConfg = null
                   /*  if (axioxConfig.params && axioxConfig.params.tk) {
                        getConfg = JSON.parse(decodeCookie(CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(axioxConfig.params.tk))))
                    } */
                    //  console.log('===axio===req===',axioxConfig.url,axioxConfig.params)
                    //  console.log('===axio===response===',axioxConfig.url,axioxConfig.params,getConfg)
                    /* if (res && getConfg && getConfg.encrypt) {
                        let customCryptoByKey = new CustomCrypto(getConfg.secret)
                        res = JSON.parse(customCryptoByKey.decrypt(res))
                        res = res.data
                    } */
                    // console.log('===axio===responseDecod===',res)
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/request/axios.js